module.exports = __webpack_public_path__ + "img/ee15437.jpg";